import { GridLogicOperator, TableVisibility } from '@warehouse/object-browser/core';
import { PersistQueryParamsConfig } from '@warehouse/shared/util';
import {
	ActionsColumnName,
	BucketColumnName,
	DurationColumnName,
	ObjectColumnName,
	EndColumnName,
	JobIdColumnName,
	ServiceColumnName,
	StartColumnName,
	StatusColumnName,
	TriggeredByColumnName,
} from '@warehouse/service-log/core';
import { ServiceLogStore } from './service-log.store';

export const SERVICE_LOG_STORAGE_KEY = 'service-log';

/**
 * Page and page size live in the URL (and page size in local storage); the table state lives in session storage,
 * the same split the Object Browser uses.
 */
export function serviceLogStoreConfig(): PersistQueryParamsConfig<ServiceLogStore> {
	return {
		page: {
			type: 'number',
			defaultValue: 1,
		},
		perPage: {
			type: 'number',
			defaultValue: 25,
			localStorageKey: SERVICE_LOG_STORAGE_KEY,
		},
		// No sorting: the Broker search has no sort parameter, rows keep its order like the Logs tab.
		sort: {
			type: 'array',
			defaultValue: [],
			sessionStorageKeyPrefix: SERVICE_LOG_STORAGE_KEY,
		},
		visibility: {
			type: 'object',
			keyName: 'column-visibility',
			defaultValue: {
				[ServiceColumnName]: true,
				[ObjectColumnName]: true,
				[BucketColumnName]: true,
				[StatusColumnName]: true,
				[TriggeredByColumnName]: true,
				[StartColumnName]: true,
				[EndColumnName]: true,
				[DurationColumnName]: true,
				[JobIdColumnName]: true,
				[ActionsColumnName]: true,
				// The shared visibility type is keyed by Object Browser fields; the Service Log reuses it with its own columns.
			} as unknown as TableVisibility,
			sessionStorageKeyPrefix: SERVICE_LOG_STORAGE_KEY,
		},
		pinned: {
			type: 'object',
			keyName: 'pinned-columns',
			defaultValue: { left: [] },
			sessionStorageKeyPrefix: SERVICE_LOG_STORAGE_KEY,
		},
		order: {
			type: 'array',
			keyName: 'column-order',
			defaultValue: [],
			sessionStorageKeyPrefix: SERVICE_LOG_STORAGE_KEY,
		},
		filter: {
			type: 'object',
			keyName: 'filters',
			defaultValue: { items: [], logicOperator: GridLogicOperator.AND },
			sessionStorageKeyPrefix: SERVICE_LOG_STORAGE_KEY,
		},
	};
}
